var locationElement = document.querySelector('.location-slider');
var urbandSlider = document.querySelector('.urband-slider');
var galerySetion = document.querySelector('.galery-setion');
var equipmentSection = document.querySelector('.equipment-section');
var contactSection = document.querySelector('.contact-section');

if (urbandSlider) {
  var firstDivChild = urbandSlider.querySelector('div');

  if (firstDivChild) {
    firstDivChild.id = 'urband';
  }
}

if (galerySetion) {
  var firstDivChild = galerySetion.querySelector('div');

  if (firstDivChild) {
    firstDivChild.id = 'galery';
  }
}

if (equipmentSection) {
  var firstDivChild = equipmentSection.querySelector('div');

  if (firstDivChild) {
    firstDivChild.id = 'equipment';
  }
}

if (contactSection) {
  var firstDivChild = contactSection.querySelector('div');

  if (firstDivChild) {
    firstDivChild.id = 'contact';
  }
}

if (locationElement) {
  locationElement.id = 'location';
}

document.addEventListener("DOMContentLoaded", function() {
  var scrollLinks = document.querySelectorAll('a[href^="#"]');

  scrollLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      var targetId = this.getAttribute('href');

      var targetSection = document.querySelector(targetId);

      if (targetSection) {
        targetSection.scrollIntoView({
          behavior: 'smooth' 
        });
      }
    });
  });
});
